import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import ErrorBoundary from 'components/ErrorBoundary';
import { Helmet } from 'react-helmet';
import { getUrlParam, getValue } from '../utils/getValue';
import setTitle from '../utils/special/setTitle';
import getTitles from '../config/getTitles';
import styles from './layouts.less';
import getSpecialClassName from '@/utils/special/specialClassName';
@connect(({ global }) => ({
  global,
}))
class Index extends Component {
  componentDidMount() {
    const {
      location: { pathname },
    } = this.props;
    if (pathname === '/') {
      router.push('/home');
    }
    const query = (this.props.location && this.props.location.query) || {};
    const {
      channel,
      recharge,
      cardType,
      dragoncode,
      language = 'zh-cn',
      showTopBar = 'true',
    } = query;
    getValue('dragoncode'); // 存起dragonpasscode
    getValue('refchannel', {
      storageType: 'session',
    }); // 存期二维码的倒计时，因为后面有些项目特殊情况不能用接口返回的flushTimer所以定制了这个，避免黄牛刷所以需要base64加密的，
    if (showTopBar) localStorage.setItem('showTopBar', showTopBar);
    if (channel) localStorage.setItem('channel', channel);
    localStorage.setItem('language', language);
    const globalPayload = {};
    if (channel) globalPayload.channel = channel;
    if (recharge) globalPayload.recharge = recharge;
    if (cardType) globalPayload.cardType = cardType;
    if (dragoncode) globalPayload.dragoncode = dragoncode;
    if (language) globalPayload.language = language;
    this.props.dispatch({
      type: 'global/setData',
      payload: globalPayload,
    });
    sessionStorage.setItem('isShowUseSucModal', 'true');
  }

  componentWillReceiveProps(newProps, oldProps) {
    const pathname = newProps.location.pathname;
    // 需要设置title的channel
    setTitle(pathname);
  }

  render() {
    const {
      location: { pathname },
    } = this.props;

    const isHaierChannel = getValue('channel') === 'haier';
    const defaultTitle = !isHaierChannel ? '龙腾出行' : '';
    const title = getTitles[pathname] || defaultTitle;
    return (
      <ErrorBoundary>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        {this.props.children}
      </ErrorBoundary>
    );
  }
}

export default Index;
